import React, { FunctionComponent } from "react"
import { iArtist } from "../../definitions/Artists"
import { useImageUrl } from "../../hooks/useImageUrl"
import { eImageVersions } from "../../definitions/Image"
import PureImage from "../../components/Image/PureImage"
import s from "./Artists.less"

const ArtistItem: FunctionComponent<iArtist> = ({
  name,
  country,
  fileVersions,
}) => {
  const url = useImageUrl(eImageVersions.LIcon, fileVersions)

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage className={s.image} src={url} />
      </div>
      <div className="content-block">
        <h3>{name}</h3>
        <span>{country}</span>
      </div>
    </div>
  )
}

export default ArtistItem
